import { ErrorBoundary } from '@sentry/react'
import React, { useCallback, useContext, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { toast } from 'react-toastify'
import { notifyGoogleAccountAssociated } from '../../../api'
import '../../../assets/styles/pages/trimMixReport.scss'
import { ErrorMsg } from '../../../components/AppMessages'
import { GlobalMSSalesGoogleAccessBanner } from '../../../components/Banners/GlobalMSSalesGoogleAccessBanner'
import { IframeLayout } from '../../../components/Layouts'
import { IframePageContent } from '../../../components/PageContent'
import { LookStudioEmbeddedLinks } from '../../../constants/globalMSSalesConstants'
import { DashboardBannerContext } from '../../../context'
import { eventTracking, MixpanelEvents } from '../../../utils/userTracking'

const GlobalMSSalesTrimMixReport = () => {
    const history = useHistory();
    const { setBannerText, setShowBanner } = useContext(DashboardBannerContext);

    useEffect(() => {
        eventTracking(MixpanelEvents.page_view, { dashboard: "Trim Mix Analysis", page: "Trim Mix Report" });
    }, []);

    useEffect(() => {
        setBannerText(<GlobalMSSalesGoogleAccessBanner />);
        setShowBanner(true);
        // DashboardBannerContext lives in App.tsx, above the router - it never unmounts on navigation,
        // so showBanner/bannerText persist across routes unless explicitly reset here (see
        // CcsMonetizationFilters.tsx's own comment on this exact leak).
        return () => {
            setShowBanner(false);
            setBannerText("");
        };
    }, []);

    const handleRequestAccess = useCallback(() => {
        notifyGoogleAccountAssociated("trim_mix_report").then((response: any) => {
            if (response?.error) {
                toast.error("Failed to update your request, please try again later");
            } else {
                toast.success("Request for access has been received");
            }
        });
    }, []);

    return (
        <IframeLayout hasFilter={true}>
            <ErrorBoundary fallback={<ErrorMsg />}>
                <div className="trim_mix_section">
                    <button className="submitrequestBtn" onClick={() => history.push("/faq/link_google_account?dashboard=trim_mix_report")}>
                        How to Link Nissan ID to Google
                    </button>
                    <button className="submitrequestBtn" onClick={handleRequestAccess}>
                        Let us know if you already have an associated Google Account to gain access
                    </button>
                </div>
                <IframePageContent
                    frameId="global_ms_sales_trim_mix_report"
                    iframeUrl={LookStudioEmbeddedLinks.trim_mix_report}
                />
            </ErrorBoundary>
        </IframeLayout>
    )
}

export default GlobalMSSalesTrimMixReport;
